import { Link } from 'react-router-dom'
import boatSvg from '../../../assets/images/boat-optimised.svg'

interface LogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  inverted?: boolean
  iconOnly?: boolean
  className?: string
  to?: string
  onClick?: () => void
}

const sizes = {
  xs: { icon: 'h-4', text: 'text-sm', gap: 'gap-0.5' },
  sm: { icon: 'h-5', text: 'text-base', gap: 'gap-0.5' },
  md: { icon: 'h-6', text: 'text-xl', gap: 'gap-1' },
  lg: { icon: 'h-8', text: 'text-2xl', gap: 'gap-1' },
  xl: { icon: 'h-10', text: 'text-3xl', gap: 'gap-1.5' },
}

export default function Logo({
  size = 'md',
  inverted = false,
  iconOnly = false,
  className = '',
  to,
  onClick,
}: LogoProps) {
  const sizeConfig = sizes[size]
  const colorClass = inverted ? 'text-white hover:text-white/80' : 'text-black hover:text-black/80'

  const content = (
    <div
      className={`flex items-center ${sizeConfig.gap} ${colorClass} transition-colors ${className}`}
    >
      <img
        src={boatSvg}
        alt=""
        className={`${sizeConfig.icon} flex-shrink-0 ${inverted ? 'invert' : ''}`}
      />
      {!iconOnly && (
        <span
          className={`font-bold ${sizeConfig.text}`}
          style={{ fontFamily: "'Instrument Serif', serif" }}
        >
          profile.work
        </span>
      )}
    </div>
  )

  if (to) {
    return (
      <Link to={to} onClick={onClick}>
        {content}
      </Link>
    )
  }

  if (onClick) {
    return (
      <button onClick={onClick} className="focus:outline-none">
        {content}
      </button>
    )
  }

  return content
}
